import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgMediaPlayCircle24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Play",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m0-18.5c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.053 17.132a.75.75 0 0 1-.75-.75V7.618a.75.75 0 0 1 1.201-.6l5.82 4.382a.754.754 0 0 1 0 1.2l-5.82 4.382a.76.76 0 0 1-.451.15m.75-8.01v5.756L14.625 12z"
}));

export { SvgMediaPlayCircle24 as default };
//# sourceMappingURL=MediaPlayCircle24.js.map
